import { ON_ORGANIZATION_CHANGE } from './actions.js';

const initialState = {
  ownerId: '',
  currencies: [],
  imageUrl: '',
  firstName: '',
  lastName: ''
};

export default (state = initialState, action) => {
  if (action.type === ON_ORGANIZATION_CHANGE) {
    return {
      ownerId: action.payload.ownerId,
      currencies: action.payload.currencies,
      imageUrl: action.payload.imageUrl,
      firstName: action.payload.firstName,
      lastName: action.payload.lastName
    };
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/organization-select/reducer.js